import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./store/index";
import "./utils/extensions.init";
import { ErrorModalProvider } from "./Context/ErrorModalContext";
import { RightSidebarProvider } from "./Context/TaskManagerNotification";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <RightSidebarProvider>
      {/* <ErrorModalProvider> */}
      <App />
      <ToastContainer position="bottom-right" />
      {/* </ErrorModalProvider> */}
    </RightSidebarProvider>
  </Provider>,
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
